import styled, { css } from 'styled-components';
import { colors } from '~/styles/colors';
import { mobileQuery } from './ds';

const PRIMARY = colors.brand.primary.base;
const STROKE = colors.stroke['soft-200'];

/** Barra das telas do Modo Eco (regra de negócio, sem equivalente no design), no estilo das abas do design. */
export const ScreenHeader = styled.div`
  display: flex;
  align-items: stretch;
  gap: 28px;
  margin-bottom: 28px;
  border-bottom: 1px solid ${STROKE};
  font-family: Inter, sans-serif;

  ${mobileQuery} {
    flex-wrap: wrap;
    gap: 0;
    margin-bottom: 16px;
  }
`;

export const ScreenTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 28px;

  /* No celular as duas telas dividem a linha e o rótulo quebra dentro da aba, se precisar. */
  ${mobileQuery} {
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
    flex-basis: 100%;
    gap: 12px;
  }
`;

export const ScreenTab = styled.button<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: -1px;
  padding: 14px 4px;
  border: none;
  border-bottom: 3px solid ${({ $selected }) => ($selected ? PRIMARY : 'transparent')};
  background: transparent;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ $selected }) => ($selected ? PRIMARY : colors.text['sub-350'])};
  cursor: pointer;
  transition: color 0.15s;

  ${mobileQuery} {
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px 6px;
    padding: 12px 2px;
    font-size: 14px;
    white-space: normal;
    text-align: center;
  }
`;

export const ActiveModeBadge = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  background: ${colors.bg['success-light']};
  font-size: 11px;
  font-weight: 700;
  color: ${colors.state.success.dark};
`;

export const StatusPill = styled.span<{ $online: boolean }>`
  display: inline-flex;
  align-items: center;
  align-self: center;
  gap: 8px;
  margin: 10px 0 10px auto;
  padding: 6px 14px 6px 12px;
  border-radius: 999px;
  background: ${({ $online }) => ($online ? PRIMARY : colors.bg['soft-400'])};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${colors.text['white-0']};

  /* No celular o selo vai para a linha de cima, como no design mobile, e as abas ficam com a largura toda. */
  ${mobileQuery} {
    order: -1;
    margin: 0 0 8px;
    align-self: flex-start;
  }

  &::before {
    content: "";
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ $online }) => ($online ? colors.celsius['spring-green'] : colors.stroke['sub-300'])};
    ${({ $online }) => $online && css`box-shadow: 0 0 0 3px ${colors.celsius['spring-green-glow']};`}
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;

export const SwitcherBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px 20px;
  border: 1px solid ${STROKE};
  border-radius: 12px;
  background: ${colors.celsius['surface-subtle']};
  font-family: Inter, sans-serif;

  ${mobileQuery} {
    flex-direction: column;
    align-items: stretch;
    padding: 14px 16px;
  }
`;

export const SwitcherInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  color: ${colors.text['sub-500']};

  & strong {
    color: ${colors.text['main-900']};
  }
`;

export const SwitcherHint = styled.span`
  font-size: 12px;
  color: ${colors.text['sub-350']};
`;

export const ReadOnlyNotice = styled.div`
  margin-bottom: 20px;
  padding: 12px 16px;
  border: 1px solid ${colors.celsius['warning-light']};
  border-radius: 8px;
  background: ${colors.celsius['warning-lighter']};
  font-family: Inter, sans-serif;
  font-size: 13px;
  color: ${colors.celsius['warning-dark']};
`;

export const ReadOnlyArea = styled.fieldset`
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  pointer-events: none;
  opacity: 0.7;
`;
